import Navbar from "./components/Navbar";
import About from "./components/About";
import Skill from "./components/Skill";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
export default function App() {
  return (
    <div>
      <Navbar />
      <About />
      <Skill />
      <Contact />
      <Footer />
    </div>
  );
}
